<template>
  <GecxLaunchScript />
  <AskAiGECX />
  <AskAITooltip />
  <GecxScript />
  <component :is="pqvComponent" v-bind="productQuickviewProps" />
</template>

<script setup>
/* v8 ignore file -- @preserve */
import AskAiGECX from './AskAIButton.common.vue';
import { useAskAI } from '@/composables/features/useAskAI';
import { defineAsyncComponent } from 'vue';
import { useAskAIQuickView } from '~/composables/features/useAskAIQuickView';

const AskAITooltip = defineAsyncComponent(() => import('./AskAITooltip.common.vue'));

const { GecxScript, GecxLaunchScript } = useAskAI();
const { pqvComponent, productQuickviewProps } = useAskAIQuickView();
</script>

<style lang="scss">
@keyframes fade-in-out-loop {
  0% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}

.gsa-loader-backdrop {
  background: rgba(0, 0, 0, 0.32);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.25s ease;
  z-index: 2147483646;
}

.gsa-loader-window {
  box-sizing: border-box;
  padding: 48px 48px;
  background: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  bottom: auto;
  right: auto;
  height: 80vh;
  width: 80vw;
  border-radius: 20px;
  transform: translate(-50%, -50%) scale(1);
  transform-origin: center center;
  transition: 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);
  opacity: 0;
  z-index: 2147483647;
  max-width: 100%;
}

.gsa-loader-close {
  position: absolute;
  top: 14px;
  right: 26px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.gsa-loader-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.gsa-loader-close::before,
.gsa-loader-close::after {
  content: '';
  position: absolute;
  width: 2px;
  height: 18px;
  background-color: #5f6368;
  border-radius: 1px;
}

.gsa-loader-close::before {
  transform: rotate(45deg);
}

.gsa-loader-close::after {
  transform: rotate(-45deg);
}

.gsa-loader-skeleton {
  background: #eee;
  height: 18px;
  border-radius: 10px;
  width: 100%;
  animation-name: fade-in-out-loop;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
}

.gsa-loader-skeleton + .gsa-loader-skeleton {
  width: 70%;
}

// global styles for gecx drawer
.gsa-loader-window.loaded {
  max-width: 606px;
  width: 100%;
  height: 100vh;
  top: 0;
  bottom: 0;
  right: 0;
  left: auto;
  border-radius: 0px;
  transform: none;
}

chat-messenger {
  // override gecx drawer properties
  --chat-messenger-internal-chat-window-z-index: 40;

  @include breakpoint(medium up) {
    --chat-messenger-internal-chat-window-width: 600px;
  }
}
</style>
